import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 29286 33255"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:481.962}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970248288880">
        <path
          d="M2163 25782c1060 0 1922-860 1922-1922 0-1061-861-1921-1922-1921s-1922 860-1922 1921c0 1062 861 1922 1922 1922zM2163 18549c1060 0 1922-860 1922-1922 0-1061-861-1921-1922-1921s-1922 860-1922 1921c0 1062 861 1922 1922 1922zM8403 25782c1061 0 1921-860 1921-1922 0-1061-860-1921-1921-1921s-1921 860-1921 1921c0 1062 860 1922 1921 1922zM8403 18549c1061 0 1921-860 1921-1922 0-1061-860-1921-1921-1921s-1921 860-1921 1921c0 1062 860 1922 1921 1922zM8403 11317c1061 0 1921-860 1921-1922 0-1061-860-1921-1921-1921s-1921 860-1921 1921c0 1062 860 1922 1921 1922zM14643 18549c1061 0 1922-860 1922-1922 0-1061-861-1921-1922-1921s-1922 860-1922 1921c1 1062 861 1922 1922 1922zM14643 11317c1061 0 1922-860 1922-1922 0-1061-861-1921-1922-1921s-1922 860-1922 1921c1 1062 861 1922 1922 1922zM14643 4084c1061 0 1922-860 1922-1922 0-1061-861-1921-1922-1921s-1922 860-1922 1921c1 1062 861 1922 1922 1922zM20884 25782c1061 0 1922-860 1922-1922 0-1061-860-1921-1922-1921-1061 0-1922 860-1922 1921 0 1062 860 1922 1922 1922zM20884 18549c1061 0 1922-860 1922-1922 0-1061-860-1921-1922-1921-1061 0-1922 860-1922 1921 0 1062 860 1922 1922 1922zM20884 11317c1061 0 1922-860 1922-1922 0-1061-860-1921-1922-1921-1061 0-1922 860-1922 1921 0 1062 860 1922 1922 1922zM27124 25782c1061 0 1921-860 1921-1922 0-1061-860-1921-1921-1921s-1921 860-1921 1921c0 1062 860 1922 1921 1922zM27124 18549c1061 0 1921-860 1921-1922 0-1061-860-1921-1921-1921s-1921 860-1921 1921c0 1062 860 1922 1921 1922zM2163 33014c1060 0 1922-860 1922-1921s-861-1922-1922-1922-1922 861-1922 1922 861 1921 1922 1921zM27124 33014c1061 0 1921-860 1921-1921s-860-1922-1921-1922-1921 861-1921 1922 860 1921 1921 1921z"
          className="fill stroke1"
          style={{
            strokeWidth: 481.962,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
